import { Redirect } from 'components';
import {
  ACCOUNT_CONFIRMATION_PATH,
  ACCOUNT_OPTIONS_PATH,
  ACCOUNT_PATH,
  DD_PORTAL_URL,
  EMAIL_CONFIRMATION_PATH,
  GROUP_INVITATION_PATH,
  LEGAL_CONFIRMATION_PATH
} from 'configs';
import {
  AccountConfirmation,
  AccountCreateEdit,
  AccountOptions,
  EmailConfirmation,
  GroupJoin
} from 'pages';
import { LegalConfirmation } from 'pages/legal-confirmation/LegalConfirmation';
import { FC } from 'react';
import { Route, Routes } from 'react-router';

export const LandingPagesRouting: FC = () => (
  <Routes>
    <Route path={ACCOUNT_OPTIONS_PATH} element={<AccountOptions />} />
    <Route path={LEGAL_CONFIRMATION_PATH} element={<LegalConfirmation />} />
    <Route path={ACCOUNT_CONFIRMATION_PATH} element={<AccountConfirmation />} />
    <Route path={ACCOUNT_PATH} element={<AccountCreateEdit />} />
    <Route path={EMAIL_CONFIRMATION_PATH} element={<EmailConfirmation />} />
    <Route path={GROUP_INVITATION_PATH} element={<GroupJoin />} />
    <Route path="*" element={<Redirect to={DD_PORTAL_URL} />} />
  </Routes>
);
